import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useFormik } from 'formik'
import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/solid'

import Button from '../../../components/Button/Button'
import InputText from '../../../components/InputText/InputText'
import {
    declineInitialValues,
    declineValidationSchema,
} from '../../../forms/EstimatesModalForm'

const DeclineEstimateModal = ({ isOpen, setIsOpen, onContinue }) => {
    const {
        getFieldProps,
        handleSubmit,
        resetForm,
        errors,
        touched,
    } = useFormik({
        initialValues: declineInitialValues,
        validationSchema: declineValidationSchema,
        onSubmit: formValues => {
            onContinue(formValues)
        },
    })

    const closeModal = () => {
        setIsOpen(!isOpen)
        resetForm()
    }

    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-200"
                    onClose={closeModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-modalBackground bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-3xl bg-white md:p-12 p-4 text-center transition-all relative flex flex-col items-center justify-start gap-y-6">
                                    <XIcon
                                        className="w-6 h-6 stroke-current absolute text-textDarkerGray top-6 right-6 cursor-pointer"
                                        onClick={closeModal}
                                    />
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg text-black90 font-semibold"
                                    >
                                        Decline Estimate
                                    </Dialog.Title>
                                    <p className="mt-1 text-textDarkGray text-sm font-normal text-left">
                                        Are you sure you want to decline this
                                        estimate? This action cannot be undone.
                                    </p>

                                    <form
                                        onSubmit={handleSubmit}
                                        className="w-full"
                                    >
                                        <InputText
                                            {...getFieldProps('declineText')}
                                            error={
                                                touched['declineText'] &&
                                                errors['declineText']
                                            }
                                            placeholder=""
                                            label="Please tell us why you’re declining this estimate:"
                                            type="textarea"
                                            additionalClass="mb-4"
                                        />
                                        <div className="w-full flex items-center justify-center gap-4 ">
                                            <Button
                                                text="Cancel"
                                                variant="tertiary"
                                                onClick={() => {
                                                    closeModal()
                                                }}
                                                className="w-1/4"
                                                type="button"
                                            />
                                            <Button
                                                text="Decline Service Estimate"
                                                variant="error"
                                                className="w-full"
                                                type="submit"
                                            />
                                        </div>
                                    </form>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

DeclineEstimateModal.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    onContinue: PropTypes.func,
}

export default DeclineEstimateModal
